import { TimeoffFeaturesFlagsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { TimeoffFeatureFlags } from 'modules/timeoff/lib/consts/TimeoffFeatureFlags'

export const useLeaveRecommendationFeatureFlag = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { loading, data } = useQuery(TimeoffFeaturesFlagsDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      featureIds: [TimeoffFeatureFlags.TIMEOFF_LEAVES_APPROVAL_RECOMMENDATION],
      companyId,
    },
  })

  const feature = data?.features?.featuresConnection?.nodes?.find(
    (f) => f.id === `${companyId}-${TimeoffFeatureFlags.TIMEOFF_LEAVES_APPROVAL_RECOMMENDATION}`
  )

  return {
    loading,
    enabled: Boolean(feature?.enabled),
  }
}
